export default "__VITE_ASSET__f9351faa__"